import { RoutePaths } from "enums/RoutePaths";
import LayoutWithSideMenu from "pages/LayoutWithSideMenu/LayoutWithSideMenu";
import Login from "pages/Login/Login";
import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import ScrollToTop from "utils/ScrollToTop";
import AuthProvider from "provider/AuthProvider";
import Quiz from "pages/Quiz/Quiz";
import Activities from "pages/Activities/Activities";
import Dua from "pages/Dua/Dua";
import Users from "pages/Users/Users";
import Scoreboard from "pages/Scoreboard/Scoreboard";
import Statistics from "pages/Statistics/Statistics";

const ProtectedRoutes: React.FC = () => {
  return (
    <Routes>
      <Route element={<LayoutWithSideMenu />}>
        {/* Redirect to quiz page for unmatched routes */}
        <Route
          path={RoutePaths.NotFound}
          element={<Navigate to={RoutePaths.Quiz} replace />}
        />
        <Route path={RoutePaths.Quiz} element={<Quiz />} />
        <Route path={RoutePaths.Scoreboard} element={<Scoreboard />} />
        <Route path={RoutePaths.Activities} element={<Activities />} />
        <Route path={RoutePaths.Dua} element={<Dua />} />
        <Route path={RoutePaths.Users} element={<Users />} />
        <Route path={RoutePaths.Statistics} element={<Statistics />} />
      </Route>
    </Routes>
  );
};

const App: React.FC = () => {
  return (
    <AuthProvider>
      <ScrollToTop />
      <Routes>
        <Route
          path={RoutePaths.Root}
          element={<Navigate to={RoutePaths.Quiz} replace />}
        />

        <Route path={RoutePaths.Login} element={<Login />} />

        <Route path={RoutePaths.NotFound} element={<ProtectedRoutes />} />
      </Routes>
    </AuthProvider>
  );
};

export default App;
